import { halfEdgeEqual } from "../half-edge/halfEdgeEqual.js";
import {} from "./Edge.js";
export function edgeEqual(x, y) {
    return ((halfEdgeEqual(x.first, y.first) && halfEdgeEqual(x.second, y.second)) ||
        (halfEdgeEqual(x.first, y.second) && halfEdgeEqual(x.second, y.first)));
}
//# sourceMappingURL=edgeEqual.js.map